
import { defineComponent, ref } from "vue";
import CodeHighlighter from "@/components/highlighters/CodeHighlighter.vue";
import { code3 } from "./data";

export default defineComponent({
  name: "clearable",
  components: {
    CodeHighlighter
  },
  setup() {
    return {
      input: ref(""),
      code3
    };
  }
});
